import type { SubCardWithAnalyticsV4Props, SubCardWithImpressionProps } from './subscriptionCardsAnalyticsUtils';
import type { CLPopoverImperativeRefHandle } from '../../common/types/componentLibrary';
import type { OnlineModel } from '../../generated/api/onlineModel';
import type {
  MobileBroadbandSubCardProps,
  SubscriptionCardOffer,
  SubscriptionCardProps,
  SubscriptionCardServiceProps,
} from '../SubscriptionCard/SubscriptionCard';
import type { MutableRefObject } from 'react';

export type SubscriptionCardWithModel = (
  | SubscriptionCardProps
  | SubCardWithAnalyticsV4Props
  | SubCardWithImpressionProps
  | MobileBroadbandSubCardProps
) & {
  onlineModel: OnlineModel;
};

interface BaseOrderProps {
  onlineModel: OnlineModel;
  quantity: number;
  offers?: SubscriptionCardOffer[];
  offerGuid?: string;
  isNewNumber?: boolean;
}

export interface PublicPageOrderProps extends BaseOrderProps {
  isAuthenticated: boolean;
  offerCode?: string;
  addonCode?: string;
}

export interface OrderProps extends BaseOrderProps {
  voucherCode?: string;
  services?: SubscriptionCardServiceProps[];
  noeOfferCode?: string;
  laitenettiOfferName?: string;
  bbOfferCode?: string;
  isAuthenticated?: boolean;
  salesProductOfferCode?: string;
}

export interface SubProps {
  analyticsIndex: number;
}

export interface VoiceSubCardProps extends SubProps {
  subscriptionCards: SubscriptionCardWithModel[];
  sharedProps: {
    isChangeOffer: boolean;
    analyticsListName: string;
    showFixedTermInfo: boolean;
    compact?: boolean;
  };
  onOrderClick: (p: PublicPageOrderProps | OrderProps) => void;
  activePopoverRef: MutableRefObject<CLPopoverImperativeRefHandle | null>;
  onSelectOffer?: (guid: string, name: string) => void;
  selectedOfferPerGroup?: Record<string, string>;
}

export enum PriceType {
  ONE_TIME_CHARGE = 'OC',
  RECURRING_CHARGE = 'RC',
}
